/**
 * Mirror of the backend role/status model (PitchBook.Core Role/UserStatus + Api Policies).
 * Client gating is cosmetic — the server enforces everything.
 */

export const Roles = {
  Coach: 'Coach',
  Admin: 'Admin',
  Developer: 'Developer',
} as const;

export type Role = (typeof Roles)[keyof typeof Roles];

const rank: Record<Role, number> = { Coach: 1, Admin: 2, Developer: 3 };

/** Roles are additive: Developer ⊇ Admin ⊇ Coach. */
export function hasRole(userRole: Role, required: Role): boolean {
  return rank[userRole] >= rank[required];
}

export type UserStatus = 'Pending' | 'Active' | 'Disabled';

export interface Me {
  userId: number;
  email: string;
  displayName: string;
  role: Role;
  status: UserStatus;
  mfaEnrolled: boolean;
  mustEnrolMfa: boolean;
  csrfToken: string;
}
